// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Bp7z","inner":"Footer_inner__G6sIQ"};